/**
 * Who may moderate (approve / reject) member Forum submissions, see the review
 * queue, and receive the "awaiting approval" push + feed row.
 *
 * Owner decision 2026-10-20: Provider Admins (L3) AND Provider Owners (L4).
 * Provider Basic (L2), Members and Independents never moderate. Deactivated
 * accounts never moderate.
 *
 * This is the SINGLE source of truth: the lambdas (review / list-review /
 * notify) and the web app (page guard, nav link, feed filter) all call it, so
 * server and UI can't drift. It deliberately does NOT widen `isL4ProviderOwner`
 * — every other L4-only gate (user management, role changes, invites,
 * deactivation, member-link approval) is unchanged.
 */
import { isLiveAccount, type AccountStateRow } from './admin-actor'
import { isIndependentUser, isMember, isProvider, resolveProviderLevel } from './member-roles'
import type { RoleProfile } from './member-roles'

/** Lowest provider level that may moderate the Forum (L3 Admin). */
export const FORUM_MODERATOR_MIN_LEVEL = 3

export function canModerateForum(profile: RoleProfile & AccountStateRow): boolean {
  if (!isLiveAccount(profile)) return false
  if (isMember(profile) || isIndependentUser(profile)) return false
  const level = resolveProviderLevel(profile)
  return (isProvider(profile) && level >= FORUM_MODERATOR_MIN_LEVEL) || level >= 4
}
